module.exports = __webpack_public_path__ + "static/media/gigapixel.6008d0ee.svg";